import LandingPage from './LandingPage.js';

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Pages/Forms/PrivateForms/LandingPage/index.js